import { render } from "./InviteUsers.vue?vue&type=template&id=70d0d486&scoped=true"
import script from "./InviteUsers.vue?vue&type=script&lang=js"
export * from "./InviteUsers.vue?vue&type=script&lang=js"

import "./InviteUsers.vue?vue&type=style&index=0&id=70d0d486&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d0d486"]])

export default __exports__